import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.scss";
import "../../styles/_common.scss";
import email from "../../assets/icons/email.png";
import whatsapp from "../../assets/icons/whatsapp.png";
import phone from "../../assets/icons/phone.png";
import FooterLinks from "./FooterLinks";
import { DirectionCheck } from "../../utils/classnameSwitch";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const openInNewTab = (event: any, url: string) => {
    event.preventDefault();
    window.open(url);
  };

  return (
    <footer className="footer container-main" dir={DirectionCheck()}>
      <div className="footer-content align-center mb-3">
        <div className="box contact-content" dir="ltr">
          <nav className="level">
            <div className="level-item ">
              <div className="contact-level-item">
                <div className="icon-holder">
                  <img src={phone} alt="phone"></img>
                </div>
                <div className="contact-info">
                  <p className="heading">{t("footer.contact.phone")}</p>
                  <a className="title" href="tel:+97142100450">
                    +971 4 210 0450
                  </a>
                </div>
              </div>
            </div>
            <div className="level-item ">
              <div className="contact-level-item">
                <div className="icon-holder">
                  <img src={email} alt="email"></img>
                </div>
                <div className="contact-info">
                  <p className="heading">{t("footer.contact.mail")}</p>
                  <a className="title" href="mailto:info@staycae.ae">
                    info@staycae.ae
                  </a>
                </div>
              </div>
            </div>
            <div className="level-item ">
              <div className="contact-level-item">
                <div className="icon-holder">
                  <img src={whatsapp} alt="whatsapp"></img>
                </div>
                <div className="contact-info">
                  <p className="heading">{t("footer.contact.whatsapp")}</p>
                  <a
                    className="title"
                    href="https://wa.me/97142100450"
                    onClick={(e: any) =>
                      openInNewTab(e, "https://wa.me/97142100450")
                    }
                  >
                    +971 4 210 0450
                  </a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <FooterLinks></FooterLinks>
    </footer>
  );
};

export default Footer;
